import React from "react";

import { Typography } from "../../UI/Typography";
import { Link } from "../Link";
import { CLIENTS_EMAIL_ADDRESS, PHONE_NUMBER_NO_OPTION } from "../../constants/general";
import { COLOR_FIORD } from "../../constants/styles";

// Shown on the dashboard when an enabled admin has not been linked to any
// networks/properties yet.
export const NoNetworksNotice: React.FC = () => (
  <>
    <Typography variant="h6" color={COLOR_FIORD} gutterBottom>
      {"Your account isn't linked to any properties yet."}
    </Typography>
    <Typography variant="body1" color={COLOR_FIORD}>
      Questions or concerns? Email{" "}
      <Link href={`mailto:${CLIENTS_EMAIL_ADDRESS}`}>{CLIENTS_EMAIL_ADDRESS}</Link> or call {PHONE_NUMBER_NO_OPTION}.
    </Typography>
  </>
);
